var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showAuthPopup)?_c('AuthPopup',{attrs:{"webview-redirect-to":_vm.createWebviewRedirectTo(),"show-close-button":false},on:{"login-success":_vm.loginSuccess,"register-success":_vm.loginSuccess}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }